// src/router.js
import { createRouter, createWebHistory } from 'vue-router'

// ===== Layout general =====
import LayoutES from '@/components/layouts/LayoutES.vue'

// ===== Views =====
import HomeColonialMarket from '@/views/HomeColonialMarket.vue'
import CategoriaVista from '@/views/CategoriaVista.vue'

const routes = [
  // ===========================
  // 🛒 SHOPIFY CHECKOUT (CRÍTICO)
  // ===========================
  {
    path: '/cart/c/:token',
    beforeEnter(to) {
      // ⚠️ Forzar carga completa FUERA del SPA
      window.location.replace(window.location.origin + to.fullPath)
    }
  },

  {
    path: '/',
    component: LayoutES,
    children: [
      {
        path: '',
        name: 'home-colonial',
        component: HomeColonialMarket
      },
      {
        path: 'departamento/:handle',
        name: 'departamento-vista',
        component: CategoriaVista,
        props: true
      },
      {
        path: 'categoria/:handle',
        name: 'categoria-vista',
        component: CategoriaVista,
        props: true
      },
      {
        path: 'categoria/ofertas/:departamento',
        name: 'ofertas-departamento',
        component: CategoriaVista,
        props: true
      },
      {
        path: 'producto/:handle',
        name: 'ProductPage',
        component: () => import('@/views/ProductPage.vue')
      },
      {
        path: 'buscar',
        name: 'busqueda',
        component: () => import('@/views/BusquedaVista.vue')
      },
      
      // ==========================================
      // 🎵 SECCIÓN ARTÍSTICA (JESÚS CAVAZOS)
      // ==========================================
      {
        path: 'musica/jesus-cavazos',
        name: 'discografia-jesus-cavazos',
        component: () => import('@/views/musicajesus.vue') 
      },
      {
        path: 'musica/jesus-cavazos/trayectoria',
        name: 'trayectoria-jesus-cavazos',
        component: () => import('@/views/trayectoria.vue') // <--- Se abre este archivo
      },
      {
  path: "/checkout-success",
  name: "CheckoutSuccess",
  component: () => import("@/views/CheckoutSuccess.vue")
},
      {
  path: "/checkout",
  name: "CustomCheckout",
  component: () => import("@/views/CheckoutPage.vue")
}
    ]
  },

  // ===========================
  // 📌 404 → REDIRECT AL HOME
  // ===========================
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,

  // ✅ CONFIGURACIÓN DE SCROLL
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

export default router